// extracted by mini-css-extract-plugin
export default {"iconsBox":"Header_iconsBox__JKfwA","logo":"Header_logo__shVBB","responsiveMenuIcon":"Header_responsiveMenuIcon__gfmoo"};